/**
* Cloud.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
*/
var Cloud = /** @class */ (function () {
    function Cloud() {
    }
    return Cloud;
}());
export { Cloud };
//# sourceMappingURL=Cloud.js.map